import {selector} from "./selector";
import {gSelector} from "../../../app/selector";
import * as form from "../../../app/form";
import {crud} from "../../../app/crud";
import {formFields, objectionFormFields} from "./form-fields";

let itemId = 0;
let isClicked = false;

const sendComplaintAction = function (e) {
    let $modal = e.data.modal;
    let $form = $modal.find("form");

    $modal.find(".js_btn_modal_save").prop("disabled", true);

    let url = "/customer/history/complaint/" + itemId;

    form.removeErrorMessages($form, formFields);
    crud
        .create(url, form.getFormData($form, formFields))
        .done((jqXHR) => {
            $modal.find(gSelector.btn.modal.save).addClass("successfully");
            form.handleSuccessResponse($form, true, jqXHR);
        })
        .fail((jqXHR) => {
            $modal.find(".js_btn_modal_save").prop("disabled", false);
            form.handleFailResponse($form, formFields, jqXHR);
        });
};

const openComplaintModal = function (e) {
    e.preventDefault();
    itemId = $(e.target).closest("span").data("id");
    const $modal = $(selector.complaintModal).modal("show");
    let $form = $modal.find("form");

    $modal.off("hide.bs.modal").on("hide.bs.modal", function (e) {
        form.removeErrorMessages($form, formFields);
        form.resetFormData($form, formFields);
        if ($modal.find(gSelector.btn.modal.save).hasClass("successfully")) {
            window.location.reload();
        }
    });

    $modal
        .find(gSelector.btn.modal.save)
        .off("click")
        .on("click", {modal: $modal}, sendComplaintAction);
};

const sendObjectionAction = function (e) {
    let $modal = e.data.modal;
    let $form = $modal.find("form");
    let url = "/customer/history/objection";

    form.removeErrorMessages($form, objectionFormFields);
    $modal.find(".js_btn_modal_save").prop("disabled", true);

    crud
        .create(url, form.getFormData($form, objectionFormFields))
        .done((jqXHR) => {
            $modal.find(gSelector.btn.modal.save).addClass("successfully");
            form.handleSuccessResponse($form, true, jqXHR);
        })
        .fail((jqXHR) => {
            $modal.find(".js_btn_modal_save").prop("disabled", false);
            form.handleFailResponse($form, objectionFormFields, jqXHR.responseJSON)
        });
};

const openObjectionModal = function (e) {
    e.preventDefault();
    let complaintId = $(e.target).closest("span").data("id");

    const $modal = $(selector.objectionModal).modal("show");
    let $form = $modal.find("form");

    $modal.find(selector.inputComplaintRequestId).val(complaintId);

    $modal.off("hide.bs.modal").on("hide.bs.modal", function (e) {
        form.removeErrorMessages($form, objectionFormFields);
        form.resetFormData($form, objectionFormFields);
        if ($modal.find(gSelector.btn.modal.save).hasClass("successfully")) {
            window.location.reload();
        }
    });

    $modal
        .find(gSelector.btn.modal.save)
        .off("click")
        .on("click", {modal: $modal}, sendObjectionAction);
};

const historyExportExcel = function (e) {
    const queryString = window.location.search;
    let url = "/customer/history/export/excel?" + queryString;
    window.location.href = url;
};

const historyExportPdf = function (e) {
    const queryString = window.location.search;
    let url = "/customer/history/export/pdf?" + queryString;
    window.location.href = url;
};

const getBank = function (e) {
    let bankId = $(selector.ddlBank).val();

    let url = `/customer/prepaid-refund-request/banks/${bankId}`
    if (bankId != '') {
        $(selector.accountZr2).prop('disabled', false)
        $(selector.accountZr3).prop('disabled', false)
        $(selector.bankUniqueNumber).prop('disabled', false)
        $(selector.bankUniqueNumber).removeClass('form-select')

    }
    else {
        $(selector.accountZr2).prop('disabled', true)
        $(selector.accountZr3).prop('disabled', true)
        $(selector.bankUniqueNumber).prop('selected', false)
        $(selector.bankUniqueNumber).prop('disabled', true)
        return
    }
    crud.show(url)
        .done((response) => {
            var $select = $(selector.bankUniqueNumber);
            var uniqueNumber = response['uniqueNumbers'];
            $select.empty();

            uniqueNumber.forEach(function (value) {
                $select.append('<option value="' + value + '">' + value + '</option>');
            });

            if (uniqueNumber.length === 1) {
                $select.val([uniqueNumber[0]]);
            }

            else if (uniqueNumber.length > 1) {
                $select.val([uniqueNumber[0]]);
                $select.addClass('form-select')
                $select.prop('disabled', false);
            }
        })
        .fail((jqXHR) => {
            if (jqXHR.status == 500) {
                window.location.reload();
            }
            form.handleFailResponse($form, formFields, jqXHR)
        });

}

const changeCountryHistory = (e) =>{
    e.preventDefault();
    if(isClicked){
        return;
    }
    isClicked = true;

    let countryId = $(e.target).val()

    window.location.href = `/customer/history?filter[country]=${countryId}`
}

export {openComplaintModal, openObjectionModal, historyExportExcel, historyExportPdf, getBank, changeCountryHistory};
